import { render, staticRenderFns } from "./diff-map.vue?vue&type=template&id=863f97e6&scoped=true&"
import script from "./diff-map.vue?vue&type=script&lang=js&"
export * from "./diff-map.vue?vue&type=script&lang=js&"
import style0 from "./diff-map.vue?vue&type=style&index=0&id=863f97e6&prod&lang=scss&"
import style1 from "./diff-map.vue?vue&type=style&index=1&id=863f97e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863f97e6",
  null
  
)

export default component.exports